import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Loading } from '@salesperformanceint/e4shared';
import BlobImage from 'components/blobImage';
import { e4Format, e4Formats } from 'helpers/dates';

export const AnswersModal = ({ data, st }) => {
    if (!data) return <Loading />;
    const questions = data.reduce((a, d) => (a.some(y => y.id === d.id) ? a : a.concat([d])), []);
    return (
        <div>
            {questions.map((req, i) => {
                const answers = data.filter(x => x.id === req.id);
                return (
                    <div key={`answer-${req.id}-${i}`} className="flex flex-top mb10">
                        <div className="flex-grow">
                            <div className="mb5">
                                <span className="mr10 text-lg">
                                    <Link to={`/knowledge-bank/${req.id}`}>{req.question}</Link>
                                </span>
                            </div>
                            {answers.map((rep, i) => (
                                <div key={`task-${req.id}-${i}`} className="flex flex-top mb5">
                                    <BlobImage
                                        height="25"
                                        className="img-circle mr10"
                                        folder="avatar"
                                        initials={rep.initials}
                                        src={rep.avatar}
                                    />
                                    <div className="flex-grow">
                                        <div>
                                            {st('From')}: {rep.full_Name}
                                        </div>
                                        <div>
                                            {st('Answered')}: {e4Format(rep.created, e4Formats.long, true)}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default withRouter(AnswersModal);
